module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/home/runner/work/ottawajs-w3c-web-sustainability-guidelines/ottawajs-w3c-web-sustainability-guidelines/src/deck.mdx",
    "dirname": "/home/runner/work/ottawajs-w3c-web-sustainability-guidelines/ottawajs-w3c-web-sustainability-guidelines/src"
  }
}];